var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-filler"},[_c('b-overlay',{attrs:{"no-wrap":"","fixed":"","show":"","z-index":"1050","opacity":0},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('div',{staticClass:"lds-ellipsis"},_vm._l((4),function(ellipse){return _c('div',{key:`ellipse-${ellipse}`})}),0)]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }